module.exports = __webpack_public_path__ + "static/img/1-5.04630d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-5.png
// module id = 259
// module chunks = 0